import * as React from 'react';
import { RequiredGuidanceActivityEnriched } from '../../typings/api-types';
import styles from '../RequiredActivitiesList/RequiredActivitiesList.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { CLASS_LEVEL_OPTIONS } from '../../shared/helpers/classLevelHelper';

type RequiredActivitiesListProps = {
  activities: RequiredGuidanceActivityEnriched[];
};

export const RequiredActivitiesList = (props: RequiredActivitiesListProps) => {
  const { t } = useTranslation();
  
  return (
    <div>
      {props.activities.map((activity) => {
        const statusClass = activity.is_overdue ? styles.overdue : styles.notOverdue;

        const due_at_level_name = CLASS_LEVEL_OPTIONS.find(option => option.value === activity.due_at_grade)?.label;
        const display_icon = activity.is_overdue ? 'exclamation-triangle' : 'calendar-days';
        return (
          <div key={activity.id} className={`${statusClass}`}>
            {}
            <FontAwesomeIcon icon={display_icon} /> {activity.name}{' '}

            {activity.due_date && (
              <span className={styles.onDate}>
                {t('guidanceSession.DUE_ON')} {activity.due_month_name} {t('guidanceSession.OF_CLASS_LEVEL')} {due_at_level_name}
              </span>
            )}

          {!activity.due_date && (
              <span className={styles.onDate}>
                {t('guidanceSession.DUE_UNKNOWN')}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RequiredActivitiesList;
export type { RequiredActivitiesListProps };
